import HumanizedVisualization from './HumanizedVisualization'

export default HumanizedVisualization
